import { fromJS, Map } from "immutable"
import actionTypes from "../../actions/actionTypes"
import requestStatus from "../../constants/requestStatus"
import config from "../../print-config.json"
import { addIdUniqToArray, deleteItemFromArray, returnStateIfNoAction } from "../helpers"
import { reorderListItems } from '../../functions/lists';
import getPrintAllFormatsSubKey from "../../functions/getPrintAllFormatsSubKey"


const getPrintTypesDefaultState = () => {
    let printData = {}

    _.keys(config.routes).map((type) => {
        let allFormats = {}
        const currentFormats = config.routes[type].formats
    
        _.keys(config.formats).map((format) => {
            const name = config.formats[format].name
            if(_.contains(currentFormats, format)) {
                allFormats[format] = {items :[]} 
            }
        })
        
        printData[type] = {allFormats}
    })

    return printData
}

const PRINT_TYPES_DEFAULT = getPrintTypesDefaultState()

const getInitState = weeks => {
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        currentWeek: weeks[1].isoWeek,
        ... PRINT_TYPES_DEFAULT
    })
}

const posterPdfCombinedRequested = (state, action) => {
    return state.set('status', requestStatus.REQUEST_PENDING)
                .set('error', Map({}));
}

const posterPdfCombinedSuccess = (state, action) => {
    return state.set('status', requestStatus.REQUEST_SUCCESS)
}

const posterPdfCombinedResetState = (state, action) => {
    return state.set('status', requestStatus.INITIALIZED)
                .set('error', null)
}

const posterPdfCombinedError = (state, action) => {
    return state.set('status', requestStatus.REQUEST_ERROR)
                .setIn(['error','message'], action.payload.errorMessage)
}

const printToolAddItem = (state, action) => {
    const { printType, printFormat, landscape, itemId } = action.payload
    const allFormatsSubKey = getPrintAllFormatsSubKey(printFormat, landscape)

    return addIdUniqToArray(
        state, 
        [printType, 'allFormats', allFormatsSubKey, 'items'], 
        itemId
    )
}

const printToolReorderItem = (state, action) => {
    const { printType, printFormat, landscape, oldIndex, newIndex } = action.payload
    const allFormatsSubKey = getPrintAllFormatsSubKey(printFormat, landscape)
    const keyArray = [printType, 'allFormats', allFormatsSubKey, 'items']

    const oldOrder = state.getIn(keyArray)
    const newOrder = reorderListItems(oldOrder, oldIndex, newIndex)

    return state.setIn(keyArray, newOrder)
}

const printToolDeleteItem = (state, action) => {
    const { printType, printFormat, landscape, itemId } = action.payload

    const allFormatsSubKey = getPrintAllFormatsSubKey(printFormat, landscape)

    return deleteItemFromArray(
        state, 
        [printType, 'allFormats', allFormatsSubKey, 'items'],
        itemId
    )
}

const printToolSetWeek = (state, action) => {
    return state.set('currentWeek', action.payload.week)
}

const chooseAndDeleteAllPrintItems = (state, action) => {
    const {printType, printFormat, items} = action.payload
    return state.setIn([printType, 'allFormats', printFormat, 'items'], fromJS(items))
}


const printTypesReducer = weeks =>(state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type) {
        case actionTypes.PRINT_DATA_PRINT_TYPES_PDF_REQUEST:
            return posterPdfCombinedRequested(state, action)
        case actionTypes.PRINT_DATA_PRINT_TYPES_PDF_SUCCESS:
            return posterPdfCombinedSuccess(state, action)
        case actionTypes.PRINT_DATA_PRINT_TYPES_PDF_RESET_STATE:
            return posterPdfCombinedResetState(state, action)
        case actionTypes.PRINT_DATA_PRINT_TYPES_PDF_ERROR:
            return posterPdfCombinedError(state, action)
        case actionTypes.PRINT_TOOL_ADD_ITEM:
            return printToolAddItem(state, action)
        case actionTypes.PRINT_TOOL_REORDER_ITEM:
            return printToolReorderItem(state, action)
        case actionTypes.PRINT_TOOL_DELETE_ITEM:
            return printToolDeleteItem(state, action)
        case actionTypes.PRINT_TOOL_SET_WEEK:
            return printToolSetWeek(state, action)
        case actionTypes.CHOOSE_AND_DELETE_ITEMS:
            return chooseAndDeleteAllPrintItems(state, action)
        default:
            return state;
    }
}

export default printTypesReducer;